'use client'
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {Box, Flex, Text} from '@chakra-ui/layout';
import {FormControl, FormErrorMessage, Input} from '@chakra-ui/react';
import {IconButton} from '@chakra-ui/button';
import {MdCheck} from 'react-icons/md';
import {forwardRef} from '@chakra-ui/system';
import useProductsApi from '../lib/useProductsApi';
import useTranslation from '../../lib/i18n/useTranslation';
const ProductForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    showOnboardingDefinition,
    onValidityChange,
    onSubmitted,
    onSubmitting,
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isValid }
  } = useForm();
  const productApi = useProductsApi();
  const onSubmit = async (data) => {
    try {
      if(onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      let newProduct;
      if(name) {
        newProduct = await productApi.insertProduct(name);
      }
      if(onSubmitted) {
        onSubmitted(newProduct);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if(onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          {showOnboardingDefinition && (
            <Box mb={3}>
              <Text fontSize="14px" fontWeight="600" mb={1}>{t('product.onboardingNameLabel')}</Text>
              <Text fontSize="14px" color="text.medium.grey">{t('product.onboardingNameDescription')}</Text>
            </Box>
          )}
          <Flex
            alignItems={'center'}
          >
            <FormControl isInvalid={errors && errors.name}>
              <Input
                placeholder={t('common.namePlaceholder')}
                {...register('name', {
                  required: true,
                  minLength: 3
                })}
              />
              <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
            </FormControl>
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='primary'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </form>
      </Box>
    </>
  );
});
export default ProductForm;
